
import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { BottomSheet } from 'react-spring-bottom-sheet'
import {ElementsConsumer, PaymentElement} from '@stripe/react-stripe-js';
import Spinner from "react-spinners/ScaleLoader";

const stateManager = require('../../../../../utils/state/stateManager');
const viewUtil = require('../../../../../utils/view/viewUtil');
const formatter = require('../../../../../utils/formatter/formatter');
const basketUtil = require('../../../../../utils/basket/basketUtil');
const constants = require('../../../../../utils/domain/constants');
class StripePaymentComponent extends Component 
{
    constructor(props) 
    {
        super(props);

        this.state = {};
        this.state.isProcessing = false;
    }

    render()
    {
        var caption = `Pay Now - ${formatter.convertToCurrencyFormat(basketUtil.getTotalBasketPrice())}`

        var footerButtonStyle = {
                                    color:`var(--button-continue-font-color)`, 
                                    background:`var(--button-continue-background-color)`,
                                    borderColor:`var(--button-continue-background-color)`,
                                    fontSize:`var(--button-continue-font-size)`,
                                    paddingLeft:'20px',
                                    paddingRight:'20px',
                                    marginRight:'5px',
                                    paddingLeft:'20px',
                                    paddingRight:'20px',
                                    paddingTop:'10px',
                                    paddingBottom:'10px',
                                    width:'80%',
                                    borderRadius:15,
                                    marginTop:'10px'
                                }

        var footer = <div style={{textAlign:'center'}}>
                        <Button style={footerButtonStyle} disabled={this.state.isProcessing}
                                onClick={()=>
                                        {
                                            this.getPayNow();
                                        }}>{caption}
                        </Button>
                    </div>;  


        
        var heightRatio = 0.60;
        var paymentComponentVisibility = "visible";
        var spinnerComponentVisibility = "collapse";
        if (this.state.isProcessing)
        {
            paymentComponentVisibility = "hidden";
            spinnerComponentVisibility = "visible";
        }

        return <BottomSheet open={true} 
                            defaultSnap={({ maxHeight }) => Math.trunc(maxHeight * heightRatio)}
                            snapPoints={({ minHeight, maxHeight }) => [Math.trunc(maxHeight * heightRatio), Math.trunc(maxHeight * heightRatio)]}
                            header="Payment"
                            footer={footer}
                            onDismiss={()=>
                            {
                                if (this.state.isProcessing)
                                    return;
                                
                                stateManager.getStore().getState().onCreditCardPaymentDismiss();
                            }}>
                    
                    <div style={{visibility:paymentComponentVisibility, marginLeft:'20px', marginRight:'20px', marginTop:'20px', marginBottom:'20px'}}>
                        <PaymentElement/>
                    </div>

                    <div style={{visibility:spinnerComponentVisibility, position:'fixed', top:'50%', left:'50%', transform:'translate(-50%, -50%)'}}>
                        <div style={{textAlign:'center', whiteSpace:'nowrap'}}>
                            Processing Payment
                        </div>
                        <div style={{textAlign:'center', whiteSpace:'nowrap'}}>
                            <Spinner color={`var(--spinner-color)`} size={40}/>
                        </div>
                    </div>

                </BottomSheet>  
    }

    async getPayNow()
    {
        try
        {
            viewUtil.clearErrors();
            this.state.isProcessing = true;
            this.setState({});
            
            const {stripe, elements} = this.props;
            if (!stripe || !elements) 
            {
                // Stripe.js has not yet loaded.
                // Make sure to disable form submission until Stripe.js has loaded.
                return;
            }
            var redirect = 'if_required';
            const result = await stripe.confirmPayment(
                                                        {
                                                            //`Elements` instance that was used to create the Payment Element
                                                            elements,
                                                            redirect
                                                        }
                                                    );
            
            if (result.error) 
            {
                this.state.isProcessing = false;
                this.setState({});
                viewUtil.showErrorAlert(result.error.message);
            } 
            else 
            {
                var state = stateManager.getStore().getState();
                var basket = state.basket;

                basket.order.paymentMethod = constants.paymentMethods.venuePaid;
                basket.creditCardTransactionResult = {};
                basket.creditCardTransactionResult.processor = "Stripe";
                basket.creditCardTransactionResult.amount = basketUtil.getTotalBasketPrice();
                basket.creditCardTransactionResult.response = result;
            
                stateManager.getStore().getState().onCreditCardPaymentCompletion();
            }
        }
        catch(error)
        {
            this.state.isProcessing = false;
            this.setState({});
            viewUtil.showErrorAlert(error);
        }
    }

}

export default function InjectedCheckoutForm() 
{
    return (
                <ElementsConsumer>
                    {({stripe, elements}) => (
                    <StripePaymentComponent stripe={stripe} elements={elements}/>
                    )}
                </ElementsConsumer>
            )
  }